import { ENDPOINT } from '~/constants';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

import {
  type ValidateLabelingPositionConsistencyPayload,
  type ValidateLabelingPositionConsistencyResponse,
} from './types';
import { zodValidateLabelingPositionConsistencySchema } from './validations';

/**
 * Validates the consistency of label positions.
 * @param queryParameters - Query parameters
 * @returns The validation result.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/labeling_position_consistency_labeling_position_consistency_get
 */
export const validateLabelingPositionConsistency = async (
  queryParameters: ValidateLabelingPositionConsistencyPayload,
) => {
  try {
    const response = await vestigasAiApi
      .get(ENDPOINT.AI.VALIDATE_LABELING_POSITION_CONSISTENCY(), {
        searchParams: queryParameters,
        validate: {
          searchParams: zodValidateLabelingPositionConsistencySchema,
        },
      })
      .json<ValidateLabelingPositionConsistencyResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error validating labeling position consistency',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
